import { ColumnDef } from "@tanstack/react-table"
import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedMessage } from "react-intl"
import { ColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { PRODUCT_TYPE } from "../../../../../../state/product/Types"
import {
    getInventoryLocationFromLocation,
    getQuantityAvailableByInventoryLocationId,
    getRemoteQuantityAvailableByInventoryLocationId
} from "../../../../../../utils/inventory/utils"
import GlobalHelper from "../../../../../GlobalHelper"
import Icon from "../../../../../icon/icon.component"

export default (columnDefinition: ColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const product = info.row.original
        const defaultValue = columnDefinition.dataAttributes?.defaultValue || "-"

        if (product) {
            const qboSyncEnabled = GlobalHelper.isQBOInventorySyncVisible(AppContext.hasFeatureIntegration(Features.InventorySync))
            const qmInventoryEnabled = AppContext.isInventoryEnabled()

            if (qboSyncEnabled || qmInventoryEnabled) {
                if (!product.isNonInventory) {
                    let inventoryQuantity: number, remoteQuantity: number
                    const location = AppContext.getUserLoggedIn().attributes.location

                    if (qmInventoryEnabled) {
                        const inventoryLocations = info.table.options.meta?.inventoryLocations ?? []
                        let inventoryLocationId = ""

                        if (inventoryLocations.length && location) {
                            const inventoryLocation = getInventoryLocationFromLocation(location.id, inventoryLocations)
                            if (inventoryLocation !== null) {
                                inventoryLocationId = inventoryLocation.id
                            }
                        }

                        if (inventoryLocationId !== "") {
                            inventoryQuantity = getQuantityAvailableByInventoryLocationId(product, inventoryLocationId)
                            remoteQuantity = getRemoteQuantityAvailableByInventoryLocationId(product, inventoryLocationId)
                        } else {
                            inventoryQuantity = 0
                            remoteQuantity = getRemoteQuantityAvailableByInventoryLocationId(product, "")
                        }
                    } else {
                        inventoryQuantity = product.type === PRODUCT_TYPE.BUNDLE
                            ? GlobalHelper.getQuantityOnHand(product)
                            : GlobalHelper.getQuantityOnHand(product, location)
                        remoteQuantity = GlobalHelper.getRemoteQuantityOnHand(product)
                    }

                    return (
                        <div>
                            <div>
                                <FormattedMessage
                                    id="generic-listing.inventory-cell-mapper.current-inventory-label"
                                    defaultMessage="{icon} {quantity}"
                                    values={{
                                        icon: <Icon value="map-marker-alt" />,
                                        quantity: inventoryQuantity,
                                    }}
                                />
                            </div>
                            {AppContext.isMultiLocation() && (
                                <div>
                                    <small>
                                        <FormattedMessage
                                            id="generic-listing.inventory-cell-mapper.remote-inventory-label"
                                            defaultMessage="{icon} {remoteQuantity}"
                                            values={{
                                                icon: <Icon value="store-alt" />,
                                                remoteQuantity,
                                            }}
                                        />
                                    </small>
                                </div>
                            )}
                        </div>
                    )
                } else {
                    return defaultValue
                }
            }
        }
        
        return defaultValue
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/InventoryCellMapper.tsx